<script>
let items = [
  {
    title: "Hem",
    href: "/shop/IboxServlet?p=SHOP&m=SHOP",
    dropdown: false,
  },
  {
    title: "Sortiment",
    href: "#",
    dropdown: [
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=1",
        name: "Bygg & inredningsbeslag",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=10",
        name: "Dörrbeslag",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=61",
        name: "Elektrisk installation",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=76",
        name: "Elektrisk låsning",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=106",
        name: "Fäst & fogmaterial",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=125",
        name: "Fönsterbeslag",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=153",
        name: "Gångjärn",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=174",
        name: "Mekanisk låsning",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=203",
        name: "Reglar",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=219",
        name: "Skjut & vikdörrsbeslag",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=233",
        name: "Uterumsbeslag",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=243",
        name: "Utrymning",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=253",
        name: "Ventiler & ventilgaller",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS479&amp;NODE=259",
        name: "Verktyg & maskiner",
        notification: null,
      },
    ],
  },
  {
    title: "Min Sida",
    href: "#",
    dropdown: [
      { href: "/shop/IboxServlet?p=IXS610", name: "Order", notification: null },
      {
        href: "/shop/IboxServlet?p=IXS615_ALL",
        name: "Leveransbesked",
        notification: "3",
      },
      {
        href: "/shop/IboxServlet?p=IXS650",
        name: "Spåra gods/Följesedlar",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS640",
        name: "Fakturor",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS613",
        name: "Mina artikelnummer",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS850",
        name: "Reklamation / retur",
        notification: "1",
      },
      {
        href: "/shop/IboxServlet?p=IXS101",
        name: "Inställningar",
        notification: null,
      },
    ],
  },
  {
    title: "Beställa",
    href: "#",
    dropdown: [
      {
        href: "/shop/IboxServlet?p=IXS820",
        name: "Produktlistor",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS810",
        name: "Massregistrera",
        notification: null,
      },
      {
        href: "/shop/IboxServlet?p=IXS880",
        name: "Order upload",
        notification: null,
      },
    ],
  },
  {
    title: "Tips & Guider",
    href: '/shop/IboxServlet?p=SHOP_BIBLIOTEK&amp;m=SHOP_BIBLIOTEK"',
    dropdown: false,
  },
  {
    title: "Kontakt",
    href: 'href="/shop/IboxServlet?p=IXS101_SID',
    dropdown: false,
  },
];
</script>

<div
  class="navbar-placeholder"
  data-spy="affix"
  data-offset-bottom=""
  data-offset-top="111"
></div>
<div
  class="fixed-nav"
  data-spy="affix"
  data-offset-bottom=""
  data-offset-top="111"
>
  <div class="col-xs-12">
    <div class="collapse navbar-collapse  navbar-secondary" id="navbar-menubar">
      <ul class="nav navbar-nav">
        {#each items as item}
          {#if item.dropdown}
            <li class="dropdown">
              <a
                href="{item.href}"
                class="dropdown-toggle"
                data-toggle="dropdown"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {item.title}
                <svg
                  width="14"
                  height="8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                ><path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M13.707.293a1 1 0 00-1.414 0L7 5.586 1.707.293A1 1 0 00.293 1.707l6 6a1 1 0 001.414 0l6-6a1 1 0 000-1.414z"
                  ></path></svg>
              </a>
              <ul class="dropdown-menu">
                {#each item.dropdown as dropdown}
                  <li>
                    <a href="{dropdown.href}" target="">
                      <div>
                        {dropdown.name}
                        {#if dropdown.notification}
                          <span
                            class="notification"
                          >{dropdown.notification}</span>
                        {/if}
                      </div>
                      <svg
                        width="7"
                        height="12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M.293.293a1 1 0 000 1.414L4.586 6 .293 10.293a1 1 0 101.414 1.414l5-5a1 1 0 000-1.414l-5-5a1 1 0 00-1.414 0z"
                        ></path>
                      </svg></a>
                  </li>
                {/each}
              </ul>
            </li>
          {:else}
            <li><a href="{item.href}">{item.title}</a></li>
          {/if}
        {/each}
        <div class="personlig-service">
          <p>Personlig service:</p>
          <a href="tel:0046104834025">
            <svg
              width="15"
              height="15"
              viewBox="0 0 15 15"
              fill="#333333"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.3459 10.4402C12.4397 9.66519 11.5201 9.19572 10.6251 9.96958L10.0906 10.4373C9.69958 10.7768 8.97255 12.3632 6.16158 9.12957C3.35121 5.90007 5.02362 5.39723 5.41523 5.06064L5.95261 4.59234C6.84296 3.81672 6.50695 2.84032 5.8648 1.83523L5.47728 1.22644C4.8322 0.223698 4.12975 -0.434847 3.23706 0.339602L2.75471 0.761071C2.36017 1.04849 1.25732 1.98275 0.989808 3.7576C0.667852 5.88719 1.68348 8.32585 4.01034 11.0016C6.33427 13.6785 8.60962 15.0231 10.765 14.9997C12.5562 14.9804 13.638 14.0192 13.9763 13.6697L14.4604 13.2477C15.3508 12.4738 14.7976 11.6859 13.8909 10.9091L13.3459 10.4402Z"
                fill=""
              ></path>
            </svg>

            010-483 40 25</a>
        </div>
      </ul>
    </div>
  </div>
</div>
